export default "__VITE_ASSET__CgWc0ki8__"